/**
 * useConflictStore — port of BigxBookApp/src/store/useConflictStore.ts.
 * Behaviour identical so the desktop app surfaces the same conflict UX.
 */
import { create } from 'zustand';

export interface SyncConflict {
  table: string;
  id: string;
}

interface ConflictState {
  conflicts: SyncConflict[];
  setConflicts: (conflicts: SyncConflict[]) => void;
  clearConflicts: () => void;
}

let autoClearTimer: ReturnType<typeof setTimeout> | null = null;

export const useConflictStore = create<ConflictState>((set) => ({
  conflicts: [],

  setConflicts: (conflicts) => {
    if (conflicts.length === 0) return;
    set({ conflicts });
    if (autoClearTimer) clearTimeout(autoClearTimer);
    autoClearTimer = setTimeout(() => {
      set({ conflicts: [] });
      autoClearTimer = null;
    }, 30_000);
  },

  clearConflicts: () => {
    if (autoClearTimer) {
      clearTimeout(autoClearTimer);
      autoClearTimer = null;
    }
    set({ conflicts: [] });
  },
}));
